class CronDataService extends BaseService
	@register()

	toCronExpression: (cron) ->
		@assertIsCronDTO(cron)

		if !cron.frequency? || !cron.timeFrom? || !cron.timeTo?
			throw new Error('Required properties are not set for cron expression')

		timeFrom = moment(cron.timeFrom * 1000)

		weekdayFrom = '*'

		if cron.frequency == 'weekly' && cron.weekdayFrom != null
			weekdayFrom = cron.weekdayFrom

		return "#{timeFrom.minutes()} #{timeFrom.hours()} * * #{weekdayFrom}"

	toCronDurationSeconds: (cron) ->
		@assertIsCronDTO(cron)

		if !cron.timeFrom? || !cron.timeTo?
			throw new Error('Required properties are not set for cron duration seconds')

		timeFrom = moment(cron.timeFrom * 1000)
		timeTo = moment(cron.timeTo * 1000)

		start = moment.utc()
			.startOf('day')
			.add(timeFrom.hour(), 'hours')
			.add(timeFrom.minute(), 'minutes')

		end = moment.utc()
			.startOf('day')
			.add(timeTo.hour(), 'hours')
			.add(timeTo.minute(), 'minutes')

		duration = moment.duration(end.diff(start)).asSeconds()

		if cron.frequency == 'weekly' && cron.weekdayFrom != null && cron.weekdayTo != null
			days = cron.weekdayTo - cron.weekdayFrom
			duration += moment.duration(days, 'days').asSeconds()

		return duration

	assertIsCronDTO: (instance) ->
		if !(instance instanceof CronDTO)
			throw new Error('Invalid cron provided. Cron must be a CronDTO instance');
